<template>
  <scrollable-container :class="$style.scrollableContainer">
    <placeholder
      v-show="isTableAwaiting"
      :text="text"
      @buttonClick="buildReport()"
    />
    <loader v-show="isTableLoading" />
    <container
      v-show="isTableReady"
      id="printable"
      :class="[{ [$style.message]: isTableAwaiting }, $style.scrollableContent]"
    >
      <internet-table
        :columns="columns"
        :report-tree="reportTree"
        report-data="messengers"
      />
    </container>
  </scrollable-container>
</template>

<script>
  import ScrollableContainer from '@/components/common/blocks/scrollable-container.vue';
  import Container from '@/components/common/blocks/container.vue';
  import Placeholder from '@/components/common/blocks/report-placeholder.vue';
  import { getMessengersStat } from '@/api/methods/reports/internet/index';
  import Loader from '@/components/common/blocks/loader.vue';
  import { REPORT_ENUM } from '@/assets/scripts/reportEnum';
  import InternetTable from './internet-table.vue';

  export default {
    components: {
      ScrollableContainer,
      Container,
      Placeholder,
      InternetTable,
      Loader,
    },
    data() {
      return {
        reportTree: [],
        text: this.$t('reports.pressButtonToGenerateReport'),
        columns: [
          { name: this.$t('reports.columns.user'), field: 'name', sort: 2 },
          { name: this.$t('reports.columns.incoming'), field: 'incoming', sort: 0 },
          { name: this.$t('reports.columns.outcoming'), field: 'outcoming', sort: 0 },
          { name: this.$t('reports.columns.suspicious'), field: 'suspicious', sort: 0 },
          { name: this.$t('reports.columns.voiceCall'), field: 'voiceCall', sort: 0 },
          { name: this.$t('reports.columns.files'), field: 'files', sort: 0 },
        ],
      };
    },
    computed: {
      isTableReady() {
        return this.$store.getters['report/getStateTable'] === REPORT_ENUM.TABLE_READY;
      },
      isTableAwaiting() {
        return this.$store.getters['report/getStateTable'] === REPORT_ENUM.REQUEST_AWAITING;
      },
      isTableLoading() {
        return this.$store.getters['report/getStateTable'] === REPORT_ENUM.TABLE_LOADING;
      },
      dateRange() {
        return this.$store.getters['filters/formattedDateRange'];
      },
      checkedComputers() {
        return this.$store.getters['pageSpecificData/checkedComputersList'];
      },
      computersTree() {
        const tree = this.$store.getters['pageSpecificData/computersTree'];
        let treeCopy = JSON.parse(JSON.stringify(tree));

        treeCopy = this.cutUncheckedNodes(treeCopy);

        return treeCopy;
      },
    },
    watch: {
      dateRange(oldValue, newValue) {
        if (
          oldValue.dateFrom.toString() !== newValue.dateFrom.toString() ||
          oldValue.dateTo.toString() !== newValue.dateTo.toString()
        ) {
          this.$store.commit('report/setStateTable', REPORT_ENUM.REQUEST_AWAITING);
        }
      },
      checkedComputers(oldArray, newArray) {
        if (oldArray !== newArray) {
          this.$store.commit('report/setStateTable', REPORT_ENUM.REQUEST_AWAITING);
        }
      },
    },
    mounted() {
      this.$store.commit('report/setStateTable', REPORT_ENUM.REQUEST_AWAITING);
    },
    methods: {
      cutUncheckedNodes(tree) {
        const childrenList = [];

        if (tree) {
          tree.forEach((node) => {
            if (node.checked) childrenList.push(node);
            else if (node.type === 'folder' && node.children) {
              node.children = this.cutUncheckedNodes(node.children);

              if (node.children.length > 0) childrenList.push(node);
            }
          });
        }

        return childrenList;
      },
      async buildReport() {
        if (this.dateRange.dateFrom && this.dateRange.dateTo && this.computersTree) {
          this.$store.commit('report/setStateTable', REPORT_ENUM.TABLE_LOADING);
          await this.fetch();
        }
      },
      async fetch() {
        this.reportTree = [];

        this.promise = await getMessengersStat(this.computersTree, this.dateRange.dateFrom, this.dateRange.dateTo).then(
          ({ data }) => {
            if (data) {
              this.reportTree = data.result.computersTree;

              this.$store.commit('report/setStateTable', REPORT_ENUM.TABLE_READY);
            } else {
              this.$store.commit('report/setStateTable', REPORT_ENUM.REQUEST_AWAITING);
            }
          },
        );
      },
    },
  };
</script>

<style lang="scss" module>
  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: white;
  }

  ::-webkit-scrollbar-thumb {
    background: $branchColor;
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: darkgray;
  }

  .scrollableContent {
    margin: 0 8px 0 0;
    padding: 0 12px 0 20px;
    box-shadow: $shadow;
    flex: 1;
  }

  .message {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
